import { Component } from 'react'
import { Menu, Empty } from 'antd';
import {
    AppstoreOutlined,
    BankOutlined,
    DollarCircleOutlined,
    FileDoneOutlined,
    FileTextOutlined,
    PhoneOutlined,
    SettingOutlined,
    ShopOutlined,
    TeamOutlined,
    UserOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { toggleSideBar } from '../../stores/componentsReducer/actions';
import helper from '../../utils/helper';

interface AccessRoute {
    path: string,
    actions?: any[],
}

interface Props extends RouteComponentProps<any> {
    is_bar_collapsed?: boolean,
    toggleSideBar: any,
    active_nav?: any,
    accessRoutes?: AccessRoute[],
}

const getRouteIcon = (path: string) => {
    const p = (path || '').toLowerCase();
    let icon = <AppstoreOutlined />;

    if (p.includes('call')) icon = <PhoneOutlined />;
    else if (p.includes('user') || p.includes('hr') || p.includes('vip')) icon = <UserOutlined />;
    else if (p.includes('compan') || p.includes('department')) icon = <BankOutlined />;
    else if (p.includes('request')) icon = <FileTextOutlined />;
    else if (p.includes('collect') || p.includes('payment') || p.includes('salary') || p.includes('settlement')) icon = <DollarCircleOutlined />;
    else if (p.includes('invoice')) icon = <FileDoneOutlined />;
    else if (p.includes('partner') || p.includes('merchant') || p.includes('shop') || p.includes('product') || p.includes('brand')) icon = <ShopOutlined />;
    else if (p.includes('group') || p.includes('team') || p.includes('assign') || p.includes('role')) icon = <TeamOutlined />;
    else if (p.includes('setting') || p.includes('config') || p.includes('global')) icon = <SettingOutlined />;

    return <span className="sideBar-icon">{icon}</span>;
}

class SideBar extends Component<Props> {
    handleNavigating = (route: string) => {
        this.props.history.push(route);
    }

    getSelectedKey = () => {
        const pathname = this.props.location.pathname || '';
        const routes = Array.isArray(this.props.accessRoutes) ? this.props.accessRoutes : [];
        const matched = [...routes]
            .sort((a, b) => String(b.path).length - String(a.path).length)
            .find((menu) => {
                const routePath = `/${menu.path}`;
                return pathname === routePath || pathname.startsWith(`${routePath}/`);
            });

        return matched ? `/${matched.path}` : pathname;
    }

    render() {
        const { is_bar_collapsed } = this.props;
        const accessRoutes = Array.isArray(this.props.accessRoutes) ? this.props.accessRoutes : [];
        const items = accessRoutes.map((menu) => {
            const actionCount = menu.actions?.length || 0;
            const label = helper.unCamelCase(menu.path);

            return {
                key: `/${menu.path}`,
                icon: getRouteIcon(menu.path),
                title: label,
                className: 'sideBar-menuItem',
                label: (
                    <span className='sideBar-item'>
                        <span className='sideBar-item__name'>{label}</span>
                        {actionCount > 0 && (
                            <span className='sideBar-item__count'>{actionCount}</span>
                        )}
                    </span>
                ),
                onClick: () => this.handleNavigating(`/${menu.path}`),
            };
        });

        return (
            <div className={`sideBar${is_bar_collapsed ? ' sideBar--collapsed' : ''}`}>
                <Menu
                    selectedKeys={[this.getSelectedKey()]}
                    mode="inline"
                    inlineCollapsed={is_bar_collapsed}
                    items={items}
                />
            </div>
        );
    }
}
const mapStateToProps = (state: any) => ({
    is_bar_collapsed: state.componentReducer.is_bar_collapsed,
    active_nav: state.componentReducer.active_nav,
    accessRoutes: state.auth.accessRoutes,
})
export default withRouter(connect(mapStateToProps, { toggleSideBar })(SideBar))
